import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import * as QRCode from 'qrcode';
import { interval, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnInit, OnDestroy {
  @ViewChild('qrCanvas', { static: true }) canvas!: ElementRef;
  @ViewChild('qrLink', { static: true }) link!: ElementRef;
  private sub!: Subscription;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.sub = interval(10 * 60 * 1000)
      .pipe(
        startWith(0),
        switchMap(() => this.http.get<{ url: string }>('/api/public/qr-code'))
      )
      .subscribe(res => {
        QRCode.toCanvas(this.canvas.nativeElement, res.url, { width: 250 });
        this.link.nativeElement.href = res.url + '&cho=1';
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
